var StateEventType;
(function(StateEventType2) {
  StateEventType2["Slices"] = "slices";
  StateEventType2["ActiveSlice"] = "activeSlice";
  StateEventType2["Message"] = "message";
})(StateEventType || (StateEventType = {}));
export {
  StateEventType
};
//# sourceMappingURL=types.js.map
